<template>
  <!-- 开箱流水控制 -->
  <div>
    <el-dialog
      :visible.sync="showMark"
      :close-on-click-modal="false"
      title="开箱流水控制"
      width="800px"
      @close="closeConfigDialog"
    >
      <div v-loading="dialogLoading">
        <p class="text-line">
          <el-switch
            v-model="backListSwitch"
            :active-value="1"
            :inactive-value="0"
            active-text="打开"
            inactive-text="关闭"
            @change="setSwitch"
          >
          </el-switch>
          <span
            style="font-size: 14px; line-height: 32px; margin-left: 20px"
            >充值金额：</span
          >
          <el-input
            style="width: 150px"
            v-model="rechargeAmount"
            placeholder="请输入充值金额"
          ></el-input>
        </p>
        <p class="text-line" v-for="(item, index) in lineList" :key="index">
          &nbsp;当日开箱&nbsp;
          <el-input
            style="width: 130px"
            v-model="item.recharge_amount"
            placeholder="请输入最小金额"
          ></el-input>
          &nbsp;--&nbsp;
          <el-input
            style="width: 130px"
            v-model="item.recharge_amount_max"
            placeholder="请输入最大金额"
          ></el-input>
          &nbsp;及以下控制出不了&nbsp;
          <el-input
            style="width: 150px"
            v-model="item.prize_amount"
            placeholder="请输入限制金额"
          ></el-input>
          &nbsp;及以上的&nbsp;
          <i
            v-if="lineList.length > 1"
            class="el-icon-remove-outline reduce_btn"
            @click="reduceTextLine(index)"
          ></i>
          <i
            v-if="lineList.length - 1 === index"
            class="el-icon-circle-plus-outline add_btn"
            @click="addTextLine"
          ></i>
        </p>
        <p class="btn-box">
          <el-button @click="closeConfigDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import { delApiData, getApiData, postApiData, patchApiData } from '../../http'
export default {
  components: {},
  props: {
    value: {
      type: Number,
      default: 2
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogLoading: false,//弹窗加载动画
      buttonLoading: false,//按钮加载动画
      backListSwitch: 0,//打开或关闭 0是关闭 1是打开
      rechargeAmount: undefined,//开箱流水控制的充值金额
      lineList: [{ recharge_amount: undefined, recharge_amount_max: undefined, prize_amount: undefined }],//设置弹窗初始数据
    }
  },
  computed: {
    showMark: {//显示标志
      get() {
        return this.visible
      },
      set() { }
    }
  },
  watch: {
    showMark: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getBackListSwitch()
          this.getConfigList()
        }
      },
    }
  },
  created() {

  },
  methods: {
    getBackListSwitch(val) {
      //获取开箱流水开关状态
      getApiData('unpack_limit/1')
        .then(res => {
          if (res) {
            res.enable ? this.backListSwitch = 1 : this.backListSwitch = 0
            this.rechargeAmount = parseFloat(res.content)
          }
        })
    },
    setSwitch(val) {
        //打开或关闭开箱流水控制开关
        if (!this.rechargeAmount || this.rechargeAmount <= 0) {
          this.$message.error("请先输入充值金额，且金额必须大于0")
          if (val === 1) {
            this.backListSwitch = 0
          } else {
            this.backListSwitch = 1
          }
          return
        }
        let params = {
          enable: val,
          content: this.rechargeAmount,
          type: 1
        }
        patchApiData(`unpack_limit`, params)
          .then(res => {
            this.$message.success("操作成功！")
          }).catch(err => {
            //修改失败还原按钮
            if (val === 1) {
              this.backListSwitch = 0
            } else {
              this.backListSwitch = 1
            }
          })
    },
    getConfigList() {
      //获取设置列表数据
      this.dialogLoading = true
      // open_box_limit 接口后跟1是充值流水,2是开箱流水
      getApiData(`open_box_limit/2`)
        .then(res => {
          if (res) {
            if (res.length > 0) {
              //不为空时赋值
              this.lineList = res
            }
          }
        }).finally(() => {
          this.dialogLoading = false
        })
    },
    addTextLine() {
      //加行
      let params = { recharge_amount: undefined, recharge_amount_max: undefined, prize_amount: undefined }
      this.lineList.push(params)
    },
    reduceTextLine(num) {
      //减行
      this.lineList.splice(num, 1)
    },
    submit() {
      //保存编辑好的表单信息
      this.buttonLoading = true
      let params
      if (this.lineList.length === 1) {
        if ((!this.lineList[0].recharge_amount || this.lineList[0].recharge_amount == 0) && (!this.lineList[0].recharge_amount_max || this.lineList[0].recharge_amount_max == 0) && (!this.lineList[0].prize_amount || this.lineList[0].prize_amount == 0)) {
          params = { data: [] };
        } else {
          params = { data: this.lineList };
        }
      } else {
        params = { data: this.lineList };
      }

      //检测最大值不能小于最小值
      if (params.data && params.data.length > 0) {
        for (let i = 0, len = params.data.length; i < len; i++) {
          if (params.data[i] && (parseFloat(params.data[i].recharge_amount) > parseFloat(params.data[i].recharge_amount_max))) {
            this.$message.error(`第${i + 1}行，最小金额不能大于最大金额`)
            this.buttonLoading = false
            return
          }
        }
      }
      
      // open_box_limit 接口后跟1是充值流水,2是开箱流水
      patchApiData(`open_box_limit/2`, params)
        .then(res => {
          this.$message.success("保存成功！")
          this.closeConfigDialog()//关闭弹窗
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    closeConfigDialog() {
      //关闭弹窗
      this.$emit('close')
      this.backListSwitch = 0//开关还原为关闭
      this.lineList = [{ recharge_amount: undefined, recharge_amount_max: undefined, prize_amount: undefined }]//还原数据
    },
  }
}
</script>
<style lang="less" scoped>
</style>